import React, { useState } from "react";
import { useMsal  } from "@azure/msal-react";
import { Button, Spinner} from "react-bootstrap";
import { User } from "../Services/User";

// Login Button Component
const MicrosoftLoginButton = () => {
    const { instance } = useMsal();
    const [isLoading, setIsLoading] =useState(false)
  
    const handleLogin = async () => {
      try {
        const loginResponse = await instance.loginPopup({
          scopes: ["email", "profile", "openid"],
        });
        // console.log(loginResponse)
  
    
        // Extract user information
        let firstName =""
        let lastName = ""
        const name = loginResponse.account?.name?.split(" ") || [];
        if (name?.length > 0) {
          firstName = name[0] ? name[0]?.charAt(0)?.toUpperCase() + name[0]?.slice(1) : "" // Capitalize first name
          lastName = name[1] ? name[1]?.charAt(0)?.toUpperCase() + name[1]?.slice(1) : ""; // Capitalize last name (if available)
       }
      
        const userEmail = loginResponse.account.username;
        setIsLoading(true)
        // Call your backend to verify if the email exists for tenant 230
        const response:any = await User.SourceLogin(userEmail,firstName, lastName)
        // console.log({response})
        if (response?.mergeToken) {
          User.ValidateUserStatus(
            response.userName,
            response.tenantID,
            "loginModal"
          ) .then((userRes: any | null) => {
            setIsLoading(false)
            window.location.href = "/home";
            localStorage.setItem(
              "showIncompleteSlideOut",
              response?.showIncompleteSlideOut?.toString()
            );
            localStorage?.setItem("PopUpState", "");

          }).catch((error) =>{
            setIsLoading(false)
            console.log(error)
          })
          }
       
        
      } catch (error) {
        setIsLoading(false)
        console.error("Login error:", error);
        // alert("Failed to login with Microsoft.");
      }
    };
  
    return (
      <Button disabled={isLoading} onClick={handleLogin} variant="primary">
        {isLoading && (
                              <Spinner
                                className="mr-2"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            )}
        Login with Microsoft
      </Button>
    );
  };
  
  export default MicrosoftLoginButton